import * as Yup from 'yup'
import FormBuilder, { FormFields } from "app/modules/tp/builders/FormBuilder";
import { Mean } from "../_models";
import { Provider } from '../../providers/_models';
import ProviderAPI from '../../providers/_requests';
import {FormikProps} from "formik";
import {RideTable} from "../partials/RideTable";

const generateEntityForm = async () =>
{
    const response = await ProviderAPI.getAllNoPagination({});
    let providers : Array<Provider> = [];

    if (response?.success){
        providers = response.data as Array<Provider>;
    }

    const formFields: FormFields<Mean> = {
        title0: {
            type: "titleView",
            title: "Info",
            icon: <i className="fa-solid fa-bus"></i>,
            columnNo: 0
        },
        id: {
            type: "text",
            key: "id",
            label: "# ID",
            attributes: {
                disabled: true
            },
            validation: Yup.number().integer().nullable(),
            columnNo: 0
        },
        provider: {
            type: "select",
            key: "provider",
            label: "Fornitore",
            isMulti: false,
            options: providers.map(provider => ({ value: (provider.id?.toString()), label: `${provider.name?? ""} ${provider.surname ?? ""}` })),
            columnNo: 0
        },
        code: {
            type: "text",
            key: "code",
            label: "Codice",
            validation: Yup.string().nullable(),
            columnNo: 0
        },
        license_plate: {
            type: "text",
            key: "license_plate",
            label: "Targa",
            validation: Yup.string()
                .max(7, 'La Targa puà essere lunga massimo 7 caratteri')
                .required('La Targa è obbligatoria'),
            columnNo: 0
        },
        seats: {
            type: "text",
            key: "seats",
            label: "N. di Posti",
            validation: Yup.number().integer().positive("Il numero deve essere maggiore di 0").nullable().typeError("Inserisci un numero valido"),
            columnNo: 0
        },
        emission_class: {
            type: "text",
            key: "emission_class",
            label: "Classe di Emissione",
            validation: Yup.string().nullable(),
            columnNo: 0
        },
        brand: {
            type: "text",
            key: "brand",
            label: "Marca",
            validation: Yup.string().nullable(),
            columnNo: 0
        },
        model: {
            type: "text",
            key: "model",
            label: "Modello",
            validation: Yup.string().nullable(),
            columnNo: 0
        },
        kilometers: {
            type: "text",
            key: "kilometers",
            label: "Chilometri",
            validation: Yup.number().integer().nullable().typeError("Inserisci un numero valido"),
            columnNo: 0
        },
        title1: {
            type: "titleView",
            title: "Giorni di Assenza",
            icon: <i className="fa-solid fa-calendar"></i>,
            columnNo: 1
        },
        meanDaysAbsences: {
            type: "absencesdaterange",
            selectOpt: [
                { label: "Manutenzione", value: "manutenzione" },
                { label: "Guasto", value: "guasto" },
                { label: "Altro", value: "altro" },
            ],
            dateRange: true,
            multiple: true,
            addLabel: <>Aggiungi giorni</>,
            key: "meanDaysAbsences",
            label: "Giorni di assenza",
            validation: Yup.array().of(Yup.object().shape({
                from: Yup.string().required('La data di inizio è obbligatoria'),
                to: Yup.string().required('La data di arrivo è obbligatoria'),
            }))
                // .test('check-validity', "La data di arrivo deve essere maggiore della data di inizio", (value) => (
                //     !!value?.every((item) =>  isDateStateValid(item as DateRangeState))
                // ))
                .nullable(),
            columnNo: 1,
        },
        title2: {
            type: "titleView",
            title: "Ore di Assenza",
            icon: <i className="fa-solid fa-calendar"></i>,
            columnNo: 2
        },
        meanHoursAbsences: {
            type: "absencestimerange",
            selectOpt: [
                { label: "Manutenzione", value: "manutenzione" },
                { label: "Guasto", value: "guasto" },
                { label: "Altro", value: "altro" },
            ],
            hoursRange: true,
            multiple: true,
            key: "meanHoursAbsences",
            label: "Ore di assenza",
            addLabel: <>Aggiungi ore</>,
            validation: Yup.array().of(Yup.object().shape({
                from: Yup.string().required("L'ora di inizio è obbligatoria"),
                to: Yup.string().required("L'ora di arrivo è obbligatoria"),
            }))
                // .test('check-validity', "L'ora di arrivo deve essere maggiore dell'ora di inizio", (value) => (
                //     !!value?.every((item) =>  isTimeStateValid(item as TimeRangeState))
                // ))
                .nullable(),
            columnNo: 2,
        },
    };
    return formFields;
};

const generateRelationTable = async () =>
{
    const formFields: FormFields<Mean> = {
        custom: {
            type: "custom",
            key: "custom",
            render: (f: FormikProps<Mean>, mean?: Mean) => { return <RideTable entities={f?.values["rides"]} filters={{mean: (mean?.id ? mean.id : -1)}} />},
        },
    };
    return formFields;
}

const MeanFormBuilder = async () => {
    const relTable: FormFields<Mean> = await generateRelationTable();
    const entityForm : FormFields<Mean> = await generateEntityForm();
    return FormBuilder<Mean>({
        formFields:
            {
                hasTabs: true,
                tabs: [
                    {
                        name: "Dati Tecnici",
                        fields: entityForm
                    },
                    {
                        name: "Corse Assegnate",
                        fields: relTable
                    },
                ]
            }
    });
};

export default MeanFormBuilder;
